export enum PeriodOption {
  ONE_DAY = 'one_day',
  ONE_WEEK = 'one_week',
  ONE_MONTH = 'one_month',
  TWO_MONTHS = 'two_months',
  QUARTER_YEAR = 'quarter_year',
  HALF_YEAR = 'half_year',
  ONE_YEAR = 'one_year'
}

export enum UpsertRentalOptType {
  INSERT,
  EDIT
}
